import React, { useState } from 'react';
import LoiNhuanApi from "service/BaoCao/LoiNhuanApi";
import { pushNotification } from "utils/notifications";
import { format, startOfYear, endOfYear } from 'date-fns';

const mapTypeToInt = (typeString) => {
    switch (typeString) {
        case 'tinchap': return 1;
        case 'camdo': return 2;
        case 'tragop': return 3;
        case 'banhang': return 4;
        case 'thungoai': return 5;
        case 'chingoai': return 6;
        case 'chinhanvay': return 7;
        case 'thutrichlap': return 8;
        case 'chitrichlap': return 9;
        default: return 1;
    }
};

const BtnXuatExcelLoiNhuan = ({ filters, type }) => {
    const [isLoading, setIsLoading] = useState(false);
    const handleExport = () => {
        if (isLoading) return;
        setIsLoading(true);
        let dateFrom = filters.dtFrom;
        let dateTo = filters.dtTo;
        if (!dateFrom || !dateTo) {
            dateFrom = startOfYear(new Date());
            dateTo = endOfYear(new Date());
        }
        const reportTypeInt = mapTypeToInt(type);
        const strFrom = format(dateFrom, 'dd/MM/yyyy');
        const strTo = format(dateTo, 'dd/MM/yyyy');
        LoiNhuanApi.exportExcel(strFrom, strTo, reportTypeInt)
            .then((response) => {
                if (response.status === 200 && response.data) {
                    const contentDisposition = response.headers["content-disposition"];
                    let fileName = `BaoCaoLoiNhuan_${type}_${strFrom}_${strTo}.xlsx`;
                    if (contentDisposition) {
                        const match = contentDisposition.match(/filename="?([^"]+)"?/);
                        if (match && match[1]) {
                            fileName = match[1];
                        }
                    }
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);

                    pushNotification("Xuất Excel thành công!", "success");
                } else {
                    pushNotification("Xuất Excel thất bại (Không có dữ liệu)!", "error");
                }
            })
            .catch((error) => {
                console.error("Lỗi khi xuất Excel:", error);
                pushNotification("Có lỗi xảy ra khi xuất file!", "error");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <button
            type="button"
            className="btn"
            onClick={handleExport}
            disabled={isLoading}
            style={{ height: '40px', fontSize: '13px', backgroundColor: "#006266", color: "white" }}
        >
            {isLoading ? (
                <>
                    <span className="spinner-border spinner-border-sm"></span> Đang xuất...
                </>
            ) : (
                <>
                    <i className="fas fa-file-excel"></i> Xuất Excel
                </>
            )}
        </button>
    );
};

export default BtnXuatExcelLoiNhuan;